import React, { useEffect } from "react";
import CheckRight from "images/check-right.png";
import CheckWrong from "images/check-wrong.png";
import Button from "helpers/button";

const first_column_style =
  "col-start-1 col-end-7 p-4 m3-[40px] border-solid border-b border-l border-gray-400 text-base flex items-center";
const second_column_style =
  "col-start-7 col-end-9 p-4 border-solid border-b border-x border-gray-400 flex justify-center flex items-center";
const third_column_style =
  "col-start-9 col-end-12 p-4 border-solid border-b border-r border-gray-400 flex justify-center flex items-center";
const check_icon_style = "w-[25px] h-[25px]";

const Header = ({ column1, column2, title }) => {
  return (
    <>
      <div
        className={`${second_column_style} border-solid border-t rounded-tl-3xl sm:border-0 sm:border-b`}
      >
        <p className="text-small sm:hidden"> {column1} </p>
        <div className="w-3.5 h-3.5 rounded-full bg-gray-600 hidden sm:block"></div>
      </div>
      <div
        className={`${third_column_style} border-solid border-t rounded-tr-3xl sm:border-0 sm:border-b`}
      >
        <div className="w-3.5 h-3.5 rounded-full bg-yellow-300 hidden sm:block"></div>
        <p className="text-small sm:hidden">{column2}</p>
      </div>
    </>
  );
};

const Row = ({ row, index }) => {
  const { title, column1, column2 } = row;
  return (
    <>
      <div
        className={`${first_column_style} ${
          index == 0 ? " border-t rounded-t-sm" : ""
        }`}
      >
        {title}
      </div>

      <div className={second_column_style}>
        <div className="flex flex-col items-center text-[10px]">
          {" "}
          <img
            alt="check-right"
            className={check_icon_style}
            src={Number(column1.oneOrZero) === 1 ? CheckRight : CheckWrong}
          />{" "}
          <p
            className={`${column1.description?.length > 15 ? "sm:hidden" : ""}`}
          >
            {column1.description}
          </p>{" "}
        </div>{" "}
      </div>

      <div className={third_column_style}>
        <div className="flex flex-col items-center text-[10px]">
          {" "}
          <img
            alt="check-right"
            className={check_icon_style}
            src={Number(column2.oneOrZero) === 1 ? CheckRight : CheckWrong}
          />{" "}
          <p
            className={`${column2.description?.length > 15 ? "sm:hidden" : ""}`}
          >
            {column2.description}
          </p>{" "}
        </div>{" "}
      </div>
    </>
  );
};

const ComparisonTable = ({ data }) => {
  const { title, headers, rows } = data;
  return (
    <div className="container">
      <h2 className="text-h2 text-green-800 font-bold font-display sm:relative">
        {title}
      </h2>

      <div className="hidden sm:block mt-6 mb-4">
        <div className="flex items-center justify-start">
          <div className="w-3.5 h-3.5 rounded-full bg-gray-600 mr-2"></div>
          <p>{headers[0]}</p>
        </div>
        <div className="flex items-center justify-start mt-3">
          <div className="w-3.5 h-3.5 rounded-full bg-yellow-300 mr-2"></div>
          <p>{headers[1]}</p>
        </div>
      </div>

      <div className="grid grid-cols-11">
        <Header column1={headers[0]} column2={headers[1]} title={title} />
        {rows.map((row, index) => (
          <Row key={index} row={row} index={index} />
        ))}
      </div>

      {data?.button && (
        <div className="flex items-center justify-center mt-8">
          <Button button={data.button} />
        </div>
      )}
    </div>
  );
};

export default ComparisonTable;
